import type { ReactNode } from "react";

import { Typography } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";
import type { FreelancerPublic } from "@js/types/freelancer";
import type { TalentReview } from "@js/types/reviews";
import { assertUnreachable } from "@js/utils";

type ReviewCardReviewTypeProps = {
  review: TalentReview;
  profile: FreelancerPublic;
};

export const ReviewCardReviewType = ({
  review,
  profile,
}: ReviewCardReviewTypeProps) => {
  const { reviewer, review_type } = review;
  let headline: ReactNode = "";
  switch (review_type) {
    case ENUMS.ReviewType.WORK_REVIEW:
      headline = `${reviewer.first_name} hired ${profile.user.first_name} at `;
      break;
    case ENUMS.ReviewType.COWORKER_REVIEW:
      headline = `${reviewer.first_name} worked with ${profile.user.first_name} at `;
      break;
    case ENUMS.ReviewType.EMPLOYMENT_REVIEW:
      return null;
    default:
      assertUnreachable(review_type);
  }

  return (
    <Typography component="p" color="grey-1" size="small">
      {headline}
      {(review_type === ENUMS.ReviewType.WORK_REVIEW ||
        review_type === ENUMS.ReviewType.COWORKER_REVIEW) && (
        <Typography
          sx={{ wordBreak: "break-word" }}
          component="span"
          size="small"
          target="_blank"
          to={`/employers/${review.employer.id}`}
          RouterLink={RouterLink}
        >
          {review.employer.name}
        </Typography>
      )}
    </Typography>
  );
};
